import { combineReducers } from "redux";
import componentStateReducer from "./componentState";
import { missingAddonsReducer } from "./missingAddons";
import userCartReducer from "./userCart";
import userReducer from "./user";
import generalUserInfoReducer from "./generalUserInfo";
import ordersInfoReducer from "./orders";
import currentProductReducer from "./currentProduct";
import originalUserCartReducer from "./originalUserCartReducer";
import pricingReducer from "./pricingReducer";
import showBannerReducer from "./showSubscriptionBanner";
import getItNowReducer from "./getItNowReducer";
import originalMissingAddonsReducer from "./originalMissingAddons";
import dietitianReducer from "./dietitian";
import referalReducer from "./referalReducer";
import orderHistoryReducer from "./orderHistoryReducer";
import accountSettingsReducer from "./accountSettingsReducer";
import myProfileStateReducer from "./myProfileState";
import checkStoreReducer from "./checkStoreReducer";
import checkoutComponentSlice from "Root/checkout/redux/slices/checkoutComponentSlice";
import checkoutUserCartSlice from "Root/checkout/redux/slices/checkoutUserCartSlice";
import checkoutPricingSlice from "Root/checkout/redux/slices/checkoutPricingSlice";
import checkoutShippingSlice from "Root/checkout/redux/slices/checkoutShippingSlice";
import checkoutBillingSlice from "Root/checkout/redux/slices/checkoutBillingSlice";
import profileSeasonalPromotionSlice from "Root/profile/redux/slices/profileSeasonalPromotionSlice";
const reducers = combineReducers({
    user: userReducer,
    components: componentStateReducer,
    userCart: userCartReducer,
    originalUserCart: originalUserCartReducer,
    pricing: pricingReducer,
    missingAddons: missingAddonsReducer,
    generalUserInfo: generalUserInfoReducer,
    ordersInfo: ordersInfoReducer,
    currentProduct: currentProductReducer,
    banner: showBannerReducer,
    originalMissingAddons: originalMissingAddonsReducer,
    getItNow: getItNowReducer,
    dietitian: dietitianReducer,
    referalInfo: referalReducer,
    orderHistory: orderHistoryReducer,
    accountSettings: accountSettingsReducer,
    myProfile: myProfileStateReducer,
    checkStore: checkStoreReducer,
    checkoutComponent: checkoutComponentSlice,
    checkoutUserCart: checkoutUserCartSlice,
    checkoutPricing: checkoutPricingSlice,
    checkoutShipping: checkoutShippingSlice,
    checkoutBilling: checkoutBillingSlice,
    profileSeasonalPromotion: profileSeasonalPromotionSlice,
});
export default reducers;
